<svelte:head>

    <link rel='stylesheet' href='/global.css' />

</svelte:head>

<script>

    import {
        HS_API_URL,
        register
    } from "./api.svelte";

    import { onMount } from "svelte";
    import { fade } from "svelte/transition"

    import dayjs from "dayjs";
    import iban from "iban"

    export const errorReasons = {
        'not_found': 'Account existiert nicht',
        'inactive': 'Bitte kontaktieren Sie unseren Support',
        'not_native': 'TODO',
        'password_incorrect': 'Falsches Passwort',
        'ratelimit': 'Bitte versuchen Sie es später nochmals',
        'fill_fields': 'Bitte füllen Sie alle Felder aus',
        'invalid_email': 'Bitte überprüfen Sie Ihre E-Mail-Adresse',
        'missing_params': 'Unerwarteter Fehler aufgetreten',
        'email_exists': 'Account mit dieser E-Mail-Adresse existiert bereits',
        'member_exists': 'Firma mit diesem Namen existiert bereits',
        'password_length': 'Mindestlänge Passwort sind 8 Zeichen',
        'code_length': 'Code muss 4 Zeichen lang sein',
        'unexpected_error_plans': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später nochmals.',
        'no_available': 'Sie können keine weiteren Locations registrieren',
        'no_integrations': 'Bitte verlinken Sie mindestens ein Portal',
        'max_integrations': 'Sie haben Ihre maximale Anzahl an verlinkten Portalen erreicht',
        'iban_length': 'Mindestlänge Iban sind 21 Zeichen',
        'iban_invalid': 'IBAN ist ungültig',
        'incorrect': 'Falscher Code'
    };

    let REGISTER_TEMPLATE = {
        'name': '',
        'external': '',
        'first_name': '',
        'last_name': '',
        'address': {
            'street': '',
            'number': '',
            'zip': '',
            'city': ''
        },
        'phone': '',
        'email': '',
        'url': '',
        'iban': '',
        'agb': false
    }

    let errorResetTimer = null;
    let formError = false;

    let saved = false;

    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            formError = false;

        }, 4000);

    };

    $: checkData = () => {
        let missingFields = [];

        if (!REGISTER_TEMPLATE['first_name']) missingFields.push("Vorname");
        if (!REGISTER_TEMPLATE['last_name']) missingFields.push("Nachname");
        if (!REGISTER_TEMPLATE['address']['street']) missingFields.push("Straße");
        if (!REGISTER_TEMPLATE['address']['number']) missingFields.push("Hausnummer");
        if (!REGISTER_TEMPLATE['address']['zip']) missingFields.push("PLZ");
        if (!REGISTER_TEMPLATE['address']['city']) missingFields.push("Stadt");
        if (!REGISTER_TEMPLATE['phone']) missingFields.push("Telefonnummer");
        if (!REGISTER_TEMPLATE['email']) missingFields.push("E-Mail");
        if (!REGISTER_TEMPLATE['url']) missingFields.push("Website");
        if (!REGISTER_TEMPLATE['agb']) missingFields.push("AGB Akzeptieren");
        if (!REGISTER_TEMPLATE['external']) missingFields.push("Mitglied KMU- und Gewerbeverband Affoltern a.A.*");

        return missingFields;
    };

    let ibanValidation = () => {

        return iban.isValid(REGISTER_TEMPLATE['iban']);
    }

    let handleRegister = () => {

        //IBAN Validation
        if (REGISTER_TEMPLATE['iban'] !==  '') {

            if (!ibanValidation()) {

                formError = 'iban_invalid'
                startErrorResetTimer();

                return;
            }

        }

        // let missingFields = checkData();
        //
        // if (missingFields.length > 0) {
        //     window.alert(`Bitte füllen Sie folgende Felder aus:\n${missingFields.join(", ")}`);
        //     return;
        // }

        register(REGISTER_TEMPLATE).then((registerResult) => {

            if (registerResult['status'] !== 'success') {

                formError = registerResult['reason'];

                return;
            }

            saved = true;
        })

    }


</script>


<div id="overview-container">

    <div id="main-wrapper">

        {#if saved}

            <div id="success-container">

                <h1>Vielen Dank für Ihre Registration!</h1>

                <span>Sie erhalten in kürze Ihre Login Daten.</span>

            </div>

        {:else}


            <div id="headline">

                <h1>Ich mache mit beim Ämtler-Bon</h1>

                <span>Meine Firma erscheint im Verzeichnis der teilnehmenden Partner</span>

            </div>

            <form on:submit|preventDefault={() => handleRegister()}>

                <div>
                    <span class="title">Firma*</span>
                    <input type="text" required id="company" bind:value={REGISTER_TEMPLATE['name']}>
                </div>

                <div>

                    <span class="title">Mitglied KMU- und Gewerbeverband Affoltern a.A.*</span>

                    <div class="radio-container">

                        <input class="box" type="radio" id="yes" name="external" required bind:group={REGISTER_TEMPLATE['external']} value="{0}">
                        <label for="yes">Ja</label>

                        <input style="margin-left: 1vh" class="box" type="radio" id="no" name="external" required bind:group={REGISTER_TEMPLATE['external']} value="{1}">
                        <label for="no">Nein</label>

                    </div>

                </div>

                <div>
                    <span class="title">Vorname*</span>
                    <input type="text" required bind:value={REGISTER_TEMPLATE['first_name']}>
                </div>

                <div>
                    <span class="title">Nachname*</span>
                    <input type="text" required bind:value={REGISTER_TEMPLATE['last_name']}>
                </div>

                <div>
                    <span class="title">Strasse*</span>
                    <input type="text" required bind:value={REGISTER_TEMPLATE['address']['street']}>
                </div>

                <div>
                    <span class="title">Nummer*</span>
                    <input type="text" required bind:value={REGISTER_TEMPLATE['address']['number']}>
                </div>

                <div>
                    <span class="title">PLZ*</span>
                    <input type="text" required bind:value={REGISTER_TEMPLATE['address']['zip']} maxlength="4">
                </div>

                <div>
                    <span class="title">Ort*</span>
                    <input type="text" required bind:value={REGISTER_TEMPLATE['address']['city']}>
                </div>

                <div>
                    <span class="title">Telefon*</span>
                    <input type="tel" required bind:value={REGISTER_TEMPLATE['phone']}>
                </div>

                <div>
                    <span class="title">E-Mail*</span>
                    <input type="email" required bind:value={REGISTER_TEMPLATE['email']}>
                </div>

                <div>
                    <span class="title">Webseite*</span>
                    <input type="text" required bind:value={REGISTER_TEMPLATE['url']}>
                </div>

                <div>
                    <span class="title">IBAN für Auszahlungen der Gutscheine</span>
                    <input type="text" bind:value={REGISTER_TEMPLATE['iban']}>
                </div>

                <div class="row">
                    <input class="box" type="checkbox" required id="agb" bind:checked={REGISTER_TEMPLATE['agb']}>
                    <label for="agb">Ich habe die <a href="https://aemtler-bon.ch/agb">AGB</a> gelesen und akzeptiert*</label>
                </div>

                {#if formError}

                    <div transition:fade id="error">

                        {errorReasons[formError]}

                    </div>

                {/if}

                <div class="btn-container">
                    <button type="submit">Senden</button>
                </div>

            </form>

        {/if}

    </div>




</div>


<style>

    #overview-container {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background-color: #EDEDED;
        /*background-color: white;*/
        justify-content: center;
        align-items: center;
        font-family: 'Raleway', sans-serif;
    }

    #main-wrapper {
        -webkit-box-shadow: 0px 3px 10px 0px rgb(73 119 172 / 8%);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        box-shadow: 0px 3px 10px 0px rgb(73 119 172 / 8%);
        background-color: white;
        padding: 5vh;
        border-radius: 1vh;
    }

    #headline {
        margin-bottom: 5vh;
    }

    #headline h1 {
        font-size: 3vh;
        margin: 0;
    }

    form {
        display: flex;
        flex-wrap: wrap;
        width: 70vh;
        column-gap: 4vh;

    }

    form div {
        display: flex;
        flex-direction: column;
    }

    form .radio-container {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    form input {
        border: 0;
        border-radius: 1vh;
        outline: 0;
        box-sizing: border-box;
        font-family: 'Raleway', sans-serif;
        font-weight: 300;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 3px 10px 0px rgb(73 119 172 / 13%);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.13);
        box-shadow: 0px 3px 10px 0px rgb(73 119 172 / 13%);
        width: 30vh;
        padding: 0.8vh;
        margin-bottom: 2.5vh;
        font-size: 1.78vh;
    }

    form .title {
        font-family: 'Raleway', sans-serif;
        margin-bottom: 0.5vh;
        font-weight: 700;
        font-size: 1.3vh;
    }

    form .box  {
        width: unset;
    }
    form .row {
        flex-direction: row;
    }

    form label {
        font-size: 1.3vh;
    }

    form label a {
        font-weight: 900;
        text-decoration: underline;
    }

    form .btn-container {
        display: flex;
        width: 100%;
        align-items: end;
    }

    form .btn-container button {
        outline: none;
        background-color: #7bc2ff;
        border: none;
        position: relative;
        font-weight: 500;
        font-size: 1.5vh;
        color: white;
        padding: 1vh 2.5vh;
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 0.8vh;
        border: 0;
        outline: 0;
        -webkit-box-shadow: 0px 3px 10px 0px rgb(73 119 172 / 8%);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        box-shadow: 0px 3px 10px 0px rgb(73 119 172 / 8%);

    }

    form input[type=radio], form input[type=checkbox] {
        cursor: pointer;
        margin: 0 1vh 0 0;
        transform: scale(1.5);
        background-color: transparent;
        border: none;
        box-shadow: unset;

    }

    #error {
        margin-top: 0.5vh;
        color: red;
        font-weight: 700;
    }




    @media (max-width: 1024px) {

        #overview-container {
            height: auto;
        }

        #main-wrapper {
            padding: 8vw;
        }

        #headline {
            margin-bottom: 5vw;
        }

        #headline h1 {
            font-size: 8vw;
        }

        form {
            width: 100%;
            flex-wrap: unset;
            flex-direction: column;
        }

        form input {
            width: 100%;
            font-size: 5vw;
        }
        form .title {
            margin-bottom: 2vw;
        }

        form .radio-container {
            margin-bottom: 3vw;
        }

        form input[type=radio], form input[type=checkbox] {
            transform: scale(1.1);
        }


    }

</style>
